import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { getMapLeaderboardScoresInputSchema } from "#/lib/serverInputSchemas";
import { loadLeaderboardEntries, type LeaderboardEntryRow } from "#/server/game/leaderboardEntries";

const LEADERBOARD_PAGE_SIZE = 100;

export const getMapLeaderboardScores = createServerFn({ method: "GET" })
  .validator(getMapLeaderboardScoresInputSchema)
  .handler(async ({ data }): Promise<{ entries: LeaderboardEntryRow[]; cursor: string | null }> => {
    setRouteAction("map_leaderboard");
    return loadLeaderboardEntries({
      mapId: data.mapId,
      limit: LEADERBOARD_PAGE_SIZE,
      cursor: data.cursor,
    });
  });
